var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 13.3333H13.3333V21.6667C13.3333 22.5833 12.5833 23.3333 11.6667 23.3333C10.75 23.3333 10 22.5833 10 21.6667V13.3333H1.66667C0.75 13.3333 0 12.5833 0 11.6667C0 10.75 0.75 10 1.66667 10H10V1.66667C10 0.75 10.75 0 11.6667 0C12.5833 0 13.3333 0.75 13.3333 1.66667V10H21.6667C22.5833 10 23.3333 10.75 23.3333 11.6667C23.3333 12.5833 22.5833 13.3333 21.6667 13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.87e39e8474faa0f74fc158327de83d40.svg";
export { ForwardRef as ReactComponent };